/** Canonical operational type codes (AccOperationalType). */
export const OPERATIONAL_ACCOUNT_TYPE_CODES = ['BANK', 'CASH', 'AP', 'AR'] as const;

export type AccountWithType = {
  id: number;
  code: string;
  name: string;
  allowOpenItems?: boolean;
  operationalType?: { id: number; code: string; name: string } | null;
  effectiveOperationalType?: { id: number; code: string; name: string } | null;
  /** @deprecated */
  accountType?: { id: number; code: string; name: string } | null;
  /** @deprecated */
  effectiveAccountType?: { id: number; code: string; name: string } | null;
};

export const effectiveTypeCode = (account: AccountWithType): string | null =>
  account.effectiveOperationalType?.code
  ?? account.operationalType?.code
  ?? account.effectiveAccountType?.code
  ?? null;

/** Bank / cash GL accounts for payment (and receipt) pickers. */
export const isBankLikeAccount = (account: AccountWithType): boolean => {
  const code = effectiveTypeCode(account);
  return code === 'BANK' || code === 'CASH';
};

/** Payable open-item accounts — prefer AP type; fall back to allowOpenItems. */
export const isApOpenItemAccount = (account: AccountWithType): boolean => {
  if (effectiveTypeCode(account) === 'AP') return true;
  return Boolean(account.allowOpenItems);
};
